import { useEffect, useState } from "react";

// Tiny pub/sub for media-library invalidation. Mutations through
// useMedia call notifyMediaChanged(); any list surface that needs
// to stay in sync reads useMediaChangeVersion() and refetches when
// the version bumps. Lets us avoid a full context refactor while
// covering every cross-surface invalidation path.

const listeners = new Set();
let version = 0;

export function notifyMediaChanged() {
  version += 1;
  listeners.forEach((cb) => cb(version));
}

export function useMediaChangeVersion() {
  const [v, setV] = useState(version);
  useEffect(() => {
    const cb = (next) => setV(next);
    listeners.add(cb);
    return () => {
      listeners.delete(cb);
    };
  }, []);
  return v;
}
